import React, {Component, useContext} from 'react';
import Typography from "@material-ui/core/Typography";
import {
    ResponsiveContainer,
} from "recharts";
import AppContext from '../../AppContext'
import {Card} from "@material-ui/core";
import CardContent from "@material-ui/core/CardContent";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import List from "@material-ui/core/List";
import ScatterPlotIcon from '@material-ui/icons/ScatterPlot';
import BarChartIcon from '@material-ui/icons/BarChart';
import WarningIcon from '@material-ui/icons/Warning';
import FormatListNumberedIcon from '@material-ui/icons/FormatListNumbered';
import ListAltSharpIcon from '@material-ui/icons/ListAltSharp';
import ArchiveIcon from '@material-ui/icons/Archive';
import {get} from 'lodash'


const DownloadPanel = props => {
    const context = useContext(AppContext);
    const pdb_link = get(context, `state.data.iterations.${context.state.iteration_id}.fitted_pdb`);
    const qual_length = get(context, `state.data.iterations.${context.state.iteration_id}.qual_report.length`);
    const whatif_link = get(context, `state.data.iterations.${context.state.iteration_id}.whatif_profiles_pdf`);
    const rms_link = get(context, `state.data.iterations.${context.state.iteration_id}.rms_analysis_pdf`);
    const noe_assign_link = get(context, `state.data.iterations.${context.state.iteration_id}.noe_restraints_assignments`);
    const noe_viol_link = get(context, `state.data.iterations.${context.state.iteration_id}.noe_restraints_violations`);
    const iter_name = get(context, `state.data.iterations.${context.state.iteration_id}.name`);
    const tar_link = get(context, `state.data.tarfile`);
    const sum_table = window.location.href + "/summary";

    return (
        <Card>
            <CardContent>
                <Typography
                    variant="h3"
                    align="center"
                    gutterBottom>
                    More results
                </Typography>
                <ResponsiveContainer
                    width="100%"
                    height={450}
                >
                    <List component="nav"
                          aria-label="more results">
			{qual_length !== 0 ?
                        <ListItem button
                                  component="a"
                                  target="_blank"
                                  href={sum_table}>
                            <ListItemIcon>
                                <ListAltSharpIcon/>
                            </ListItemIcon>
                            <ListItemText
                                primary="Summary table of structural statistics"/>
                        </ListItem>
			  : null
			}
                        {pdb_link &&
                        <ListItem button
                                  component="a"
                                  target="_blank"
                                  href={pdb_link}>
                            <ListItemIcon>
                                <ScatterPlotIcon/>
                            </ListItemIcon>
                            <ListItemText
                                primary="PDB ensemble"/>
                        </ListItem>
                        }
                        {qual_length !== 0 ?
                            <ListItem button
                                      component="a"
                                      target="_blank"
                                      href={whatif_link}>
                                <ListItemIcon>
                                    <BarChartIcon/>
                                </ListItemIcon>
                                <ListItemText
                                    primary="Per residue WHATCHECK graph"/>
                            </ListItem>
                            : null
                        }
                        {iter_name !== "REFINE" ?
                            <React.Fragment>
                                {iter_name !== "IT 0" ?
                                    <ListItem button
                                              component="a"
                                              target="_blank"
                                              href={rms_link}>
                                        <ListItemIcon>
                                            <BarChartIcon/>
                                        </ListItemIcon>
                                        <ListItemText
                                            primary="RMS of NOE violations graph"/>
                                    </ListItem>
                                    : null
                                }
                                {noe_assign_link &&
                                <ListItem button
                                          component="a"
                                          target="_blank"
                                          href={noe_assign_link}>
                                    <ListItemIcon>
                                        <FormatListNumberedIcon/>
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="NOE restraints assignments"/>
                                </ListItem>
                                }
                                {noe_viol_link &&
                                <ListItem button
                                          component="a"
                                          target="_blank"
                                          href={noe_viol_link}>
                                    <ListItemIcon>
                                        <WarningIcon/>
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="NOE restraints violations"/>
                                </ListItem>
                                }
                            </React.Fragment>
                            : null
                        }
                        {tar_link &&
                        <ListItem button
                                  component="a"
                                  target="_blank"
                                  href={tar_link}>
                            <ListItemIcon>
                                <ArchiveIcon/>
                            </ListItemIcon>
                            <ListItemText
                                primary="Full ARIA run archive"/>
                        </ListItem>
                        }
                    </List>
                </ResponsiveContainer>
            </CardContent>
        </Card>
    );
};


export default DownloadPanel;